import FirstVisitConversionModule from "./firstVisitConversionModule";
import FirstVisitConversionSaga from "./redux/firstVisitConversionSagas";
import FirstVisitConversionReducer from "./redux/firstVisitConversionReducer";

export default {
  Component: FirstVisitConversionModule,
  moduleName: "firstVisitConversion",
  saga: FirstVisitConversionSaga(),
  reducer: FirstVisitConversionReducer
};
